import { api } from "@/lib/api";

export async function fetchPaymentConfig() {
  const { data } = await api.get("/payments/config");
  return data;
}

export async function createCheckout(packageId, code) {
  const { data } = await api.post("/payments/checkout", {
    packageId,
    originUrl: window.location.origin,
    ...(code && code.trim() ? { code: code.trim() } : {}),
  });
  return data; // { url, session_id }
}

export async function fetchCheckoutStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data; // { status, payment_status, plan_activated, user }
}

export async function openBillingPortal() {
  const { data } = await api.post("/payments/portal", {
    originUrl: window.location.origin,
  });
  return data; // { url }
}
